.viewDetailsModalPage {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	box-sizing: border-box;
	align-items: flex-start;
	width: 100%;
}

.detailsSectionWrapper {
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
}

.titleSection {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	align-items: flex-start;
}
